import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { UPLOAD_STATUS } from "../../previewDocuments/upload/DocumentUpload";

function AddDocument({ documents, dispatchUpdateAction, title = "", disabled, color }) {
  const { t } = useTranslation();

  const addDocument = useCallback(() => {
    documents.push({
      uploadStatus: UPLOAD_STATUS.NOT_STARTED,
      uploadError: null,
      uploadProgress: 0,
      label: "", // Sets value of input field hence empty string is used
      link: null,
      file: null,
      href: null,
      color: color,
      supplementRequired: true,
      required: false,
    });
    dispatchUpdateAction();
  }, [dispatchUpdateAction, documents, color]);

  return (
    <>
      <FontAwesomeIcon icon={faPlus} className="has-text-grey is-clickable" onClick={addDocument} />
      <span className="ml-2">
        {title !== "" ? title : t("requests.reviewDocuments.additionalDocs.addDocument")}
      </span>
    </>
  );
}

export default AddDocument;
